import * as yup from "yup";
import { addressFieldsetSchema } from "components/Shared/Forms/AddressFieldset";
import { phoneNumberFieldsetSchema } from "components/Shared/Forms/PhoneInput";
import {
  RetailerCategoryReviewOption,
  RetailerPricingStrategyOption,
  RetailerSlottingRequiredOption,
  RetailerType,
} from "__generated__/gql/graphql";
import { getEnumSchema, getNullableEnumSchema } from "./utils";

export const name = yup.string().nullable().required().trim().label("Name");

export const uniqueSuffix = yup.string().ensure().trim().label("Unique Suffix");

export const retailerType = getEnumSchema<RetailerType>(RetailerType)
  .label("Type")
  .required();

export const parentId = yup.string().uuid().nullable().label("Parent");

export const website = yup.string().url().trim().nullable().label("Website");

export const numStores = yup.number().nullable().min(0).label("Store Count");

export const description = yup.string().ensure().trim().label("Description");

export const slottingRequired =
  getNullableEnumSchema<RetailerSlottingRequiredOption>(
    RetailerSlottingRequiredOption,
  ).label("Slotting Required?");

export const pricingStrategy =
  getNullableEnumSchema<RetailerPricingStrategyOption>(
    RetailerPricingStrategyOption,
  ).label("Pricing Strategy");

export const categoryReview =
  getNullableEnumSchema<RetailerCategoryReviewOption>(
    RetailerCategoryReviewOption,
  ).label("Category Review");

export const headquartersAddress = addressFieldsetSchema;

export const headquartersPhoneNumber = phoneNumberFieldsetSchema;

export const channelIds = yup
  .array()
  .of(yup.string().uuid().required())
  .label("Channels")
  .ensure()
  .default([]);

export const regionIds = yup
  .array()
  .of(yup.string().uuid().required())
  .label("Regions")
  .ensure()
  .default([]);

export const distributionCenterIds = yup
  .array()
  .of(yup.string().uuid().required())
  .label("Distribution Centers")
  .ensure()
  .default([]);

export const FLAG_RETAILER_TYPES: RetailerType[] = [
  RetailerType.CHAIN,
  RetailerType.AFFILIATION,
];

export const isAnchor = yup
  .bool()
  .label("Anchor Account?")
  .when("retailerType", {
    is: (rt: RetailerType) => FLAG_RETAILER_TYPES.includes(rt),
    otherwise: (s) =>
      s.isFalse("An “Anchor Account” must be a “Chain” retailer."),
  });

export const affiliation = yup
  .string()
  .min(2)
  .trim()
  .default(null)
  .nullable()
  .transform((v: string | null | undefined) => (v === "" ? null : v))
  .when("retailerType", {
    is: RetailerType.INDEPENDENT,
    otherwise: (s) =>
      s.is(
        [null],
        "An “Affiliation” can only be set on an “Independent” retailer.",
      ),
  })
  .label("Affiliation");

export const notes = yup.string().trim().nullable().label("Notes");

export const isArchived = yup.bool().default(false).defined().label("Archive?");

export const retailerChannelIds = yup
  .array()
  .of(yup.string().uuid().required())
  .ensure()
  .default([])
  .label("Channels");

export const tags = yup
  .array()
  .of(yup.string().required().trim().defined().ensure())
  .ensure()
  .default([])
  .label("Tags");
